// GW 監査スケジュール API クライアント。
// GET/PUT/DELETE /gw/audit/schedule を呼び出してスケジュール設定を取得・更新・削除する。
// ApiClient に乗せることで認証・エラー正規化を委譲する。SF schedule-api.ts をミラー（/gw パス）。
import type { ApiClient } from "../api/client";

export interface ScheduleApiDeps {
  readonly apiClient: ApiClient;
}

// バックエンド /gw/audit/schedule のレスポンス型（GwScheduleRecord のフロント向けビュー）。
export interface ScheduleDto {
  readonly enabled: boolean;
  readonly frequency?: "weekly" | "monthly";
  readonly dayOfWeek?: number;
  readonly dayOfMonth?: number;
  readonly time?: string;
  readonly timezone?: string;
  readonly status?: string;
  readonly lastRunAt?: string;
}

// PUT /gw/audit/schedule のリクエストボディ型。
// 通知先はバックエンドがテナント管理者から解決するため、フロントは送信しない。
export interface SchedulePutBody {
  readonly frequency: "weekly" | "monthly";
  readonly dayOfWeek: number;
  readonly dayOfMonth: number;
  readonly time: string;
}

// GET /gw/audit/schedule → 現在のスケジュール設定を取得する。
export async function getSchedule(deps: ScheduleApiDeps): Promise<ScheduleDto> {
  return deps.apiClient.get<ScheduleDto>("/gw/audit/schedule");
}

// PUT /gw/audit/schedule → スケジュール設定を更新する。
export async function putSchedule(deps: ScheduleApiDeps, body: SchedulePutBody): Promise<ScheduleDto> {
  return deps.apiClient.put<ScheduleDto>("/gw/audit/schedule", body);
}

// DELETE /gw/audit/schedule → スケジュール設定を削除する（無効化）。
export async function deleteSchedule(deps: ScheduleApiDeps): Promise<ScheduleDto> {
  return deps.apiClient.del<ScheduleDto>("/gw/audit/schedule");
}
